import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import LoginPage  from './containers/LoginPage';
import ChangePasswordPage from './containers/ChangePasswordPage';
import AccountChoicesPage from './containers/AccountChoichesPage';
import AccountAlreadyExist from './containers/AccountAlreadyExist';
import AccountCreated from './containers/AccountCreated';
import HandleExternalRequest from './containers/HandleIntegrationRequest';
import GenericNotFound from './containers/GenericNotFount';
import { PrivateRoute } from './PrivateRoute';
import { baseUrl, urls } from './utils/urls.config';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faLock, faInfoCircle, faThumbsUp} from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

library.add(faUser, faLock, faEnvelope, faInfoCircle, faThumbsUp);

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <Switch>
            <Route exact path={urls.home.path}  component={LoginPage}/>
            <PrivateRoute exact path={urls.change.path} component={ChangePasswordPage}/>
            <PrivateRoute exact path={urls.choices.path} component={AccountChoicesPage}/>
            <PrivateRoute exact path={urls.exists.path} component={AccountAlreadyExist}/>
            <PrivateRoute exact path={urls.created.path} component={AccountCreated}/>
            <Route exact path='/integration'  component={HandleExternalRequest}/>
            <Route component={GenericNotFound} />
        </Switch>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

